/**
 * 工程基础配置
 */
import JsCookie from "js-cookie";
import { LanguageCode } from "@al/base-lib";
import { CtxType } from "@al/next/al-ex";

import { getCookieOpts } from ".";

// app外设置默认语言才有效
export function parseLanguageStr(language: string): LanguageCode | undefined {
  const langs = language.split(",");
  for (let i = 0; i < langs.length; i++) {
    const [langType] = langs[i].split(";");
    // 暂时不区分不同国家同种语言的语言类型，比如en-us也只用en作为语言
    const [langCode] = langType.split("-");
    // 过滤掉中文，暂时c端没有中文的使用场景
    if (langCode in LanguageCode && langCode !== "zh") {
      return langCode as LanguageCode;
    }
  }
}

// app外设置默认语言才有效
export function getDefaultLanguageCode(ctx?: any): LanguageCode {
  const req = ctx.req;
  // 服务端推导
  if (req && req.headers && req.headers["accept-language"]) {
    const acceptLanguage = req.headers["accept-language"];
    return parseLanguageStr(acceptLanguage) || LanguageCode.en;
  }
  // 客户端推导
  if (process.browser) {
    return parseLanguageStr(navigator.language) || LanguageCode.en;
  }
  return LanguageCode.en;
}

/**
 * 获取cookie值
 */
export function getValueFromCookie(req?: any, key?: string): string | null | undefined {
  if (!key) {
    return null;
  }

  if (process.server && req) {
    return req.cookies?.[key];
  } else if (process.browser) {
    return JsCookie.get(key);
  }
}

/**
 * cookie 设置
 */
export function setValueToCookie({ ctx, key, value }: { ctx: CtxType; key: string; value: string | number }): void {
  const opts = getCookieOpts(ctx.req || {});

  if (process.server && ctx.res) {
    ctx.res?.cookie(key, value ? `${value}` : "", opts);
  } else if (process.browser) {
    value ? JsCookie.set(key, `${value}`, opts) : JsCookie.remove(key, opts);
  }
}

/**
 * 判断是否是手机端
 */
export function isMobile(): boolean {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
}

export function getReqCookieByName(name: string, cookie?: string): string | undefined {
  if (!cookie) return;
  const cookieArr = cookie.split("; ");
  for (let index = 0; index < cookieArr.length; index++) {
    const [key, val] = cookieArr[index].split("=");
    if (key === name) {
      return val;
    }
  }
}

/*判断客户端类型*/
export function machineType(): string {
  if (process.browser) {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
    if (isAndroid) {
      return "Android";
    } else if (isIOS) {
      return "IOS";
    } else {
      return "PC";
    }
  }
  return "";
}

/*是否是ios*/
export function isIOS(): boolean {
  return process.browser ? machineType() === "IOS" : false;
}

/*是否是安卓*/
export function isAndroid(): boolean {
  return process.browser ? machineType() === "Android" : false;
}
